var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"vh-desc"},[_vm._v(_vm._s(_vm.$t('lang.k_178001')))])
}
var staticRenderFns = []

export { render, staticRenderFns }